import React, { useState, useEffect } from 'react';
import { animated, config, useTransition } from '@react-spring/web';
import { mergeClassNames } from '../../../../utils';
import { Fixed } from '../../ScrollProgression';
import MaskContainer from './MaskContainer';
import Spot from './Spots';
import styles from './index.module.scss';

export default function ImageSpots({
  spots,
  heroImage,
  infocardAlternatePos = false,
  inViewportProximity,
  overlapBottomOfViewport,
  scrollToParent,
  className = '',
  style = {},
}) {
  let [activeSpot, setActiveSpot] = useState(null);
  spots = spots ? spots : [];

  useEffect(() => {
    if (!overlapBottomOfViewport) setActiveSpot(null);
  }, [overlapBottomOfViewport]);

  useEffect(() => {
    if (activeSpot) scrollToParent();
  }, [activeSpot, scrollToParent]);

  let [transitions] = useTransition(
    spots,
    (...args) =>
      void console.log({ args }) || {
        enter: { opacity: 1.0 },
        leave: { opacity: 0.0, pointerEvents: 'none' },
        config: config.slow,
      },
    [spots]
  );

  if (!spots) return null;

  return (
    <div className={mergeClassNames(styles.imageSpots, className)} style={style}>
      <Fixed id="image-spots" hide={!inViewportProximity} breakOverlay>
        <div className={styles.placeholder}>
          {heroImage}
          <aside className={styles.spotContainer} style={{ pointerEvents: activeSpot ? 'none' : 'auto' }}>
            {transitions((props, item, _, index) => (
              <animated.div style={props}>
                <Spot style={style} key={index} spot={item} onClick={setActiveSpot} queuePosition={index} />
              </animated.div>
            ))}
          </aside>
        </div>
        {spots.map((spot, index) => {
          return (
            <MaskContainer
              spot={spot}
              key={index}
              closeFn={setActiveSpot}
              isActive={spot === activeSpot}
              alternatePos={infocardAlternatePos}
            />
          );
        })}
      </Fixed>
    </div>
  );
}
